// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__7RJ-F","active":"downloadDropdown_active__owHfj"};